import { Controller } from "@hotwired/stimulus"

// Controls the Table Definition Clone dialog
// Expects:
// - data-table-clone-existing-branch-ids-value: JSON array of branch IDs where the TD already exists
// Targets: warning, select
export default class extends Controller {
  static targets = ["warning", "select", "warningText"]
  static values = { existingBranchIds: Array, defaultBranchId: Number, tableName: String }

  connect() {
    // Set default selection if provided
    if (this.hasSelectTarget) {
      const defId = this.defaultBranchIdValue
      if (defId && !this.selectTarget.value) {
        this.selectTarget.value = String(defId)
      }
      this.updateWarning()
    }
  }

  updateWarning() {
    if (!this.hasSelectTarget || !this.hasWarningTarget) return
    const selected = Number(this.selectTarget.value)
    const exists = this.existingBranchIdsValue.includes(selected)
    this.warningTarget.classList.toggle("hidden", !exists)
    if (exists && this.hasWarningTextTarget) {
      const selectedText = this.selectTarget.options[this.selectTarget.selectedIndex]?.text || "the target branch"
      const name = this.hasTableNameValue ? this.tableNameValue : "This table definition"
      this.warningTextTarget.textContent = `The "${name}" table definition already exists in the "${selectedText}" branch. If you continue the clone process, the table definition in branch ${selectedText} will be overwritten. Any changes you have made to the existing table definition in the ${selectedText} branch will be lost.`
    }
  }
}
